import styled from "styled-components";

export const ModalRowWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-content: space-around;
  justify-content: space-between;
  margin-top: 10px;

  &.error-id {
    border: 1px solid #ff4d4f;
  }

  .error-message {
    text-align: right;
    font-size: 12px;
    color: #ff4d4f;
  }
`;

export const ContainerSelect = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-right: 5px;

  &.error-id {
    border: 1px solid #ff4d4f;
  }

  &::placeholder {
    color: rgba(0, 0, 0, 0.25);
  }
`;
